import CONTENT from '../../DOM/content/CONTENT.js';
import FIELDSET, { Hide, Hideable, Show } from '../../DOM/form/fieldset/FIELDSET.js';
import PAYLOAD from '../../DOM/form/PAYLOAD.js';
import { HTMLELEMENT } from '../../../enums/HTMLELEMENT.js';
import { HTTPMETHOD } from '../../../enums/HTTPMETHOD.js';
import DIV from '../../DOM/div/DIV.js';
import EL from '../../EL/EL.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import { FORMENCTYPE } from '../../../enums/FORMENCTYPE.js';
import { FORMTARGET } from '../../../enums/FORMTARGET.js';
// Model Structure
export const formAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['action', '#'],
    ['method', HTTPMETHOD.POST],
    ['enctype', FORMENCTYPE.URLENCODED],
    ['target', FORMTARGET.SELF],
    ['novalidate', false]
]);
export const formData = makeDataStruct([
    ['fieldsets', []],
    ['onSend'],
    ['onSuccess'],
    ['onError'],
    ['onReset']
]);
export const formModel = makeStruct([
    ['attributes', formAttr],
    ['data', formData]
]);
// Simplified Model
export function form(name, className, action, method, fieldsets) {
    return {
        attributes: formAttr(name, className, action, method),
        data: formData(fieldsets)
    };
}
/** A generic HTML Form */
export default class FORM extends CONTENT {
    constructor(node, model) {
        super(node, HTMLELEMENT.FORM, model);
        this.implement(new Hideable(this));
        this.addConstructor('FIELDSET', this.addFieldset.bind(this));
        if (model.data.fieldsets) {
            model.data.fieldsets.forEach((fs) => this.addFieldset(fs));
        }
    }
    /** Constructs a Fieldset for this FORM */
    addFieldset(model) {
        return this.addChild(new FIELDSET(this, model));
    }
    /** Returns an array of FIELDSET(s), optionally filtered to the specified name
        @param name Optional name to filter search
    */
    getFieldset(name) {
        return this.get(name, 'FIELDSET');
    }
    addDiv(model) {
        return this.addChild(new DIV(this, model));
    }
    /** Sets the form method */
    setMethod(method = HTTPMETHOD.POST) {
        this.setAttribute('method', method);
        return this;
    }
    /** Sets the form action */
    setAction(action) {
        this.el.setAttribute('action', action);
        return this.setAttribute('action', action);
    }
    /** Gets this form's ACTION attribute */
    getAction() {
        return this.el.getAttribute('action') || '';
    }
    /** Disables all fieldsets within this form*/
    lock() {
        this.getFieldset().forEach((i) => i.disable());
    }
    // /** HTML encodes all form element values */
    // htmlEncodeValues(): void {
    // 	try {
    // 		for (let e = 0; e < this.el.elements.length; e++) {
    // 			let type = this.el.elements[e].type.toUpperCase();
    // 			switch (type) {
    // 				case HTTPINPUTTYPE.SELECTONE:
    // 					console.log('HTMLEncode Value', this.el.elements[e].value);
    // 					break;
    // 				case HTTPINPUTTYPE.TEXT:
    // 				case HTTPINPUTTYPE.TEXTAREA:
    // 				case HTTPINPUTTYPE.EMAIL:
    // 				case HTTPINPUTTYPE.PASSWORD:
    // 				case HTTPINPUTTYPE.HIDDEN:
    // 				case HTTPINPUTTYPE.BUTTON:
    // 					this.el.elements[e].value = this.htmlEncode(this.el.elements[e].value);
    // 					break;
    // 				case HTTPINPUTTYPE.FIELDSET:
    // 				case HTTPINPUTTYPE.NUMBER:
    // 				case HTTPINPUTTYPE.CHECKBOX:
    // 				case HTTPINPUTTYPE.SUBMIT:
    // 					break;
    // 				default:
    // 					console.warn('Unrecognized type', type);
    // 			}
    // 		}
    // 	} catch (e) {
    // 		console.log(this.toString() + '.htmlEncodeValues() failed.');
    // 		throw e;
    // 	}
    // }
    // /** Flags the given element as invalid
    // 	@param {HTMLElement} element The form element
    //     @returns {boolean} Returns false;
    // */
    // setInvalid(element: HTMLElement): boolean {
    // 	this.payload.isValid = false;
    // 	element.focus();
    // 	element.setAttribute('data-valid', this.payload.isValid);
    // 	console.log(element.name + ' is invalid', element, this.payload);
    // 	element.previousSibling.classList.add('invalid'); // Set label class to 'invalid'
    // 	return false;
    // }
    // /** Flags the given element as valid
    // 	@param {HTMLElement} element The form element
    // */
    // setValid(element: HTMLElement): boolean {
    // 	element.classList.remove('invalid');
    // 	element.setAttribute('data-valid', this.payload.isValid);
    // 	return true;
    // }
    // /** Validates the given element as a STRING using HTML5 validation
    //     @param {HTMLElement} element The Input element
    // */
    // validateString(element: HTMLElement): boolean {
    // 	let isValid = true;
    // 	if (element.required) {
    // 		switch (element.tagName) {
    // 			case 'INPUT':
    // 			case 'SELECT':
    // 				if (element.checkValidity()) {
    // 					isValid = element.value === '' ? this.setInvalid(element) : this.setValid(element);
    // 				}
    // 				break;
    // 			case 'TEXTAREA':
    // 				if (element.checkValidity()) {
    // 					isValid = element.text === '' ? this.setInvalid(element) : this.setValid(element);
    // 				}
    // 				break;
    // 			default:
    // 				console.warn('Failed to validate ' + element.tagName);
    // 				this.setInvalid(element);
    // 		}
    // 	}
    // 	return isValid;
    // }
    // /** Simple number validation
    //     @param {HTMLElement} element The Input element
    // */
    // validateNumber(element: HTMLElement): boolean {
    // 	if (element.required) {
    // 		return element.checkValidity() ? this.setValid(element) : this.setInvalid(element);
    // 	}
    // 	return this.setValid(element);
    // }
    // /** Simple SELECT validation
    //     @param {HTMLElement} element The Input element
    // */
    // validateSelect(element: HTMLSelectElement): boolean {
    // 	if (element.required) {
    // 		return element.selectedIndex > 0 ? this.setValid(element) : this.setInvalid(element);
    // 	}
    // 	return this.setValid(element);
    // }
    // /** Simple CHECKBOX validation
    //     @param {HTMLElement} element The Input element
    // */
    // validateCheckbox(element: HTMLInputElement): boolean {
    // 	if (element.required) {
    // 		return element.checked ? this.setValid(element) : this.setInvalid(element);
    // 	}
    // 	return this.setValid(element);
    // }
    // /** Validate the current form and return true if form is valid
    //     Note that this is a simple form of validation that occurs on the
    //     client side and should not be used as a substitution for
    //     server side validation.
    //     For loop outperforms forEach because of break
    //     @see https://thejsguy.com/2016/07/30/javascript-for-loop-vs-array-foreach.html
    //     @returns {object} The validation payload
    // */
    // validate(): { isValid: boolean, formName: string } {
    // 	this.htmlEncodeValues();
    // 	this.payload = {
    // 		isValid: true,
    // 		formName: this.el.name
    // 	};
    // 	for (let e = 0; e < this.el.elements.length; e++) {
    // 		let element = this.el.elements[e];
    // 		let fieldset = element.closest('fieldset') || element; // https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
    // 		//console.log('Validating ' + element.name, element.disabled);
    // 		if (element.disabled || fieldset.disabled) {
    // 			console.log('Disabled Element', element);
    // 		} else {
    // 			switch (element.tagName) {
    // 				case HTMLELEMENT.INPUT:
    // 				case HTMLELEMENT.TEXTAREA:
    // 				case HTMLELEMENT.SELECT:
    // 					this.validateInput(element);
    // 					break;
    // 				case HTMLELEMENT.FIELDSET:
    // 				case HTMLELEMENT.BUTTON:
    // 					break;
    // 				default:
    // 					console.warn(this.toString() + '.validate()', element.tagName);
    // 			}
    // 		}
    // 	}
    // 	if (!this.payload.isValid) {
    // 		console.log('Validation Result: ' + this.payload.isValid);
    // 	}
    // 	return this.payload;
    // }
    // /** Performs basic validation of an INPUT element using the appropriate validation rules
    //     based on its 'TYPE' attribute.  Valid results are appended to the Form Payload
    //     @param {HTMLElement} element HTMLElement
    // */
    // validateInput(element: EL): void {
    // 	if (element.getAttribute('name') === 'undefined' || element.getAttribute('name') === '') {
    // 		console.warn('Unnamed element exists in ' + this.toString(), element);
    // 	} else {
    // 		switch (element.getAttribute('type')) {
    // 			case HTTPINPUTTYPE.HIDDEN:
    // 			case HTTPINPUTTYPE.INPUT:
    // 			case HTTPINPUTTYPE.TEXT:
    // 			case HTTPINPUTTYPE.EMAIL:
    // 			case HTTPINPUTTYPE.TEL:
    // 			case HTTPINPUTTYPE.PASSWORD:
    // 			case HTTPINPUTTYPE.TEXTAREA:
    // 				this.validateString(element);
    // 				break;
    // 			case HTTPINPUTTYPE.NUMBER:
    // 				this.validateNumber(element, this.payload);
    // 				break;
    // 			case HTTPINPUTTYPE.CHECKBOX:
    // 				this.validateCheckbox(element, this.payload);
    // 				break;
    // 			case HTTPINPUTTYPE.SELECTONE:
    // 				this.validateSelect(element, this.payload);
    // 				break;
    // 			default:
    // 				console.warn('Unable to validate unidentified form element type.', element.type, element.value);
    // 		}
    // 	}
    // }
    /** Resets the form and any validation notifications */
    reset() {
        this.el.reset();
        this.getFieldset().forEach((fieldset) => fieldset.reset());
    }
    getResults() {
        let results = {};
        this.getFieldset().forEach((fieldset) => results[fieldset.getName()] = fieldset.getResults());
        return results;
    }
    getFormFields() {
        let formfields = [];
        this.getFieldset().forEach((fieldset) => {
            fieldset.getFormFieldGroup().forEach((formFieldGroup) => {
                formFieldGroup.getFormFields().forEach((formField) => {
                    formfields.push(formField);
                });
            });
        });
        return formfields;
    }
    getFields() {
        let fields = [];
        this.getFieldset().forEach((fieldset) => {
            fieldset.getFormFieldGroup().forEach((formFieldGroup) => {
                formFieldGroup.getFormFields().forEach((formField) => {
                    let field = formField.getField();
                    if (field !== null) {
                        fields.push(field);
                    }
                });
            });
        });
        return fields;
    }
}
export { EL, FIELDSET, Hideable, Hide, PAYLOAD, Show };
